<div class="step-container">
  <h2 class="step-title">Verificación de celular</h2>
  <p class="step-subtitle">Ingrese el código de 6 dígitos que recibió por SMS.</p>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="step-form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Código de verificación</mat-label>
      <input
        matInput
        formControlName="code"
        type="text"
        placeholder="000000"
        maxlength="6"
        inputmode="numeric"
        autocomplete="one-time-code" />
      <mat-icon matPrefix>sms</mat-icon>
      <mat-error *ngIf="form.get('code')?.hasError('required')">
        El código es obligatorio.
      </mat-error>
      <mat-error *ngIf="form.get('code')?.hasError('pattern') || form.get('code')?.hasError('minlength')">
        Ingrese un código de 6 dígitos.
      </mat-error>
    </mat-form-field>

    <div *ngIf="errorMessage" class="error-message">
      <mat-icon>error_outline</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

    <button
      mat-raised-button
      color="primary"
      class="action-button"
      type="submit"
      [disabled]="loading">
      <mat-spinner *ngIf="loading" diameter="24" class="button-spinner"></mat-spinner>
      <span *ngIf="!loading">Verificar</span>
    </button>
  </form>
</div>
